import { Vector2Tuple } from 'three';

export const applyProps = <
  T extends {
    position: Vector2Tuple;
    rotation: number;
    visible: boolean;
  }
>(
  instance: T,
  props: GraphNodeProps<Node>
) => {
  Object.entries({ visible: true, position: [0, 0], rotation: 0, ...props }).forEach(
    ([key, value]) => {
      switch (key) {
        case 'position': {
          instance.position = Array.isArray(value) ? (value as Vector2Tuple) : [0, 0];
          break;
        }
        case 'rotation': {
          instance.rotation = typeof value === 'number' ? value : 0;
          break;
        }
        case 'visible': {
          instance.visible = typeof value === 'boolean' ? value : true;
          break;
        }
      }
    }
  );
};
